// loading.js
import React from 'react';

const Loading = () => {
  return (
    <div className='loading-container'>
      <p>Loading ...</p>
    </div>
  );
};

export default Loading;